import cardImageUrl from '../assets/images/credit-card.png';

function Directive() {
  return {
    restrict: 'E',
    replace: true,
    scope: {
      outgoingPayment: '='
    },
    controller: [
      '$scope',
      ($scope) => {
        $scope.cardImageUrl = cardImageUrl;
      }
    ],
    template: `<div class="wex-card">
  <p class="card-amount">
    <strong>{{ outgoingPayment.amount }}</strong>
  </p>
  <p class="card-number">
    {{ outgoingPayment.data.number | creditcard }}
  </p>
  <p class="card-expiration">
    {{ outgoingPayment.data.expiration | moment : 'MM/YY' }}
  </p>
  <p class="card-cvv">
    {{ outgoingPayment.data.cvv }}
  </p>
  <img class="img-responsive" src="{{ cardImageUrl }}">
</div>`
  };
}

Directive.$inject = [];

export default Directive;



// WEBPACK FOOTER //
// ./src/directives/wexCard.js